 <div class="name">
  <ng-container
    *ngTemplateOutlet="nameContent()">
  </ng-container>
</div>

<div class="text-wrapper">
  <ng-container
    *ngTemplateOutlet="textContent()">
  </ng-container>
</div>
